import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudTypographyModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionModule } from 'shared/components/accordion/accordion.module';

import { AppointmentDetailsTriageDataComponent } from './appointment-details-triage-data.component';

@NgModule({
	declarations: [AppointmentDetailsTriageDataComponent],
	exports: [AppointmentDetailsTriageDataComponent],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FreudTypographyModule,
		AccordionModule,
	],
})
export class AppointmentDetailsTriageDataModule {}
